import { colorTokens } from "constants/colorTokens";
import { tagTypeMaps } from "../constants";

function Badges({ tags }) {
  const getBadgeColor = (tagType) =>
    tagTypeMaps[tagType] || colorTokens["neutral-grey-primary"];
  return (
    <div className="d-flex gap-1 flex-wrap">
      {tags.map((tag, index) => (
        <span
          key={index}
          className={"badge"}
          style={{
            backgroundColor: colorTokens["neutral-grey-lightest"],
            border: `1px solid ${colorTokens["neutral-grey-lighter"]}`,
            color: getBadgeColor(tag.tag_type),
          }}
          title={tag.description}
        >
          {tag.tag}
        </span>
      ))}
    </div>
  );
}

export default Badges;
